module.exports = __webpack_public_path__ + "media/images/athletes/2202-6c7bd3a42a5870547ceb49df0fca8cc3.png";